import graphql from "../../graphql";

export default {
  namespaced: true,
  getters: {
    departments: state => filter =>
      state.departments.filter(department =>
        Boolean(department.toLowerCase().match(filter.toLowerCase()))
      ),
    modalEmployee: state => state.modalEmployee,
    getEmployees: state => (filter, { sortBy, asc }) => {
      const multiplier = asc ? 1 : -1;
      return state.employees
        .filter(
          employee =>
            Boolean(employee.firstName.toLowerCase().match(filter.toLowerCase())) ||
            Boolean(employee.lastName.toLowerCase().match(filter.toLowerCase()))
        )
        .sort((a, b) => (a[sortBy] >= b[sortBy] ? 1 * multiplier : -1 * multiplier));
    },
    translations: state => key => {
      if (state.translations[key]) {
        return state.translations[key];
      } else {
        console.warn(`translation-key "${key}" missing`);
        return "";
      }
    },
  },
  actions: {
    fetchEmployees: ({ commit }) => {
      graphql.query({ query: voucherEmployeesQuery }).then(response => {
        if (response.data) {
          commit("setEmployees", response.data.voucherEmployees.nodes);
          commit("setDepartments", response.data.voucherEmployeeDepartments);
        } else {
          commit(
            "flashMessages/setMessages",
            response.errors.map(error => ["error", error.message]),
            { root: true }
          );
        }
      });
      commit("setEmployees", []);
    },
    upsertEmployee: ({ commit, state }, data) => {
      graphql
        .mutation({
          query: data.voucherEmployeeId ? updateEmployeeMutation : createEmployeeMutation,
          variables: { voucherEmployee: data },
        })
        .then(response => {
          if (response.data) {
            commit(
              "upsertEmployee",
              data.voucherEmployeeId
                ? response.data.updateVoucherEmployee.voucherEmployee
                : response.data.createVoucherEmployee.voucherEmployee
            );
            commit(
              "setDepartments",
              data.voucherEmployeeId
                ? response.data.updateVoucherEmployee.departments
                : response.data.createVoucherEmployee.departments
            );
            commit(
              "flashMessages/setMessages",
              [
                [
                  "notice",
                  data.voucherEmployeeId
                    ? state.translations["update_success"]
                    : state.translations["create_success"],
                ],
              ],
              { root: true }
            );
          } else {
            commit(
              "flashMessages/setMessages",
              response.errors.map(error => ["error", error.message]),
              { root: true }
            );
          }
        });
    },
    replenishForEmployee: ({ commit, state }, data) => {
      graphql
        .mutation({ query: replenishVoucherEmployeeMutation, variables: data })
        .then(response => {
          if (response.data) {
            commit("upsertEmployee", response.data.replenishVoucherEmployee.voucherEmployee);
            commit(
              "flashMessages/setMessages",
              [["notice", state.translations["succeessful_replenishment"]]],
              { root: true }
            );
          } else {
            commit(
              "flashMessages/setMessages",
              response.errors.map(error => ["error", error.message]),
              { root: true }
            );
          }
        });
    },
    setTranslations: ({ commit }, data) => commit("setTranslations", data),
    setModalEmployee: ({ commit }, employee) => commit("setModalEmployee", employee),
  },
  mutations: {
    setEmployees: (state, employees) => (state.employees = employees),
    setDepartments: (state, departments) => (state.departments = departments),
    setTranslations: (state, translations) => (state.translations = translations),
    setModalEmployee: (state, employee) =>
      (state.modalEmployee = employee
        ? { ...employee }
        : {
            name: "",
            department: "",
            replenishPeriod: "not_recurring",
            amount: 0,
            id: "",
          }),
    upsertEmployee: (state, data) => {
      const index = state.employees.findIndex(employee => employee.id === data.id);
      if (data.id && index !== -1) {
        state.employees.splice(index, 1, data);
      } else {
        state.employees.push(data);
      }
    },
  },
  state: {
    employees: [],
    translations: {},
    modalEmployee: {},
    departments: [],
  },
};

window.graphql = graphql;

const voucherEmployeesQuery = `query {
  voucherEmployees {
    nodes {
      firstName
      lastName
      department
      amount
      replenishPeriod
      replenishedAt
      voucherCode{ code }
      id
    }
  }
  voucherEmployeeDepartments
}`;

const replenishVoucherEmployeeMutation = `mutation($voucherEmployeeId: ID!, $amount: Float) {
        replenishVoucherEmployee(input: { voucherEmployeeId: $voucherEmployeeId, amount: $amount }) {
          voucherEmployee {
            id
            firstName
            lastName
            amount
            department
            replenishPeriod
            replenishedAt
            amount
            employer { id }
            voucherCode{ code }
          }
        }
      }
`;

const createEmployeeMutation = `mutation($voucherEmployee: CreateVoucherEmployeeInput!) {
        createVoucherEmployee(input: $voucherEmployee) {
          voucherEmployee {
            id
            firstName
            lastName
            amount
            department
            replenishPeriod
            replenishedAt
            amount
            employer { id }
            voucherCode{ code }
          }
          departments
        }
      }
`;

const updateEmployeeMutation = `mutation($voucherEmployee: UpdateVoucherEmployeeInput!) {
        updateVoucherEmployee(input: $voucherEmployee) {
          voucherEmployee {
            id
            firstName
            lastName
            amount
            department
            replenishPeriod
            replenishedAt
            employer { id }
            voucherCode{ code }
          }
          departments
        }
      }
`;
